// extracted by mini-css-extract-plugin
export default {"container":"fH07i","content":"etyR0"};